import { useEffect, useState } from "react";

/**
 * Simulates a short data-fetch delay so list pages can show a loading state.
 * Re-runs whenever any of the provided keys change.
 */
export function useSimulatedLoading(deps: unknown[] = [], delay = 420): boolean {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = window.setTimeout(() => setLoading(false), delay);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return loading;
}